import React, { Component } from 'react'
import NotificationList from './notification_list';
import { Switch } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

 class NotificationPage extends Component {
    render() {
        return (
            <div>
                 <Switch>
                    <Route path="/notifications" component={NotificationList}/>
                    {/* <Route path="/settings/users" component={UserList}/> */}
                    <Redirect from="*" to= "/notiifications"/>
                </Switch>
                {/* <NotificationList/> */}
            </div>
        )
    }
}

export default NotificationPage
